module.exports = __webpack_public_path__ + "static/img/xj_icon6.7cd20ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xj_icon6.png
// module id = fC+U
// module chunks = 4